import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { SiGoogle, SiInstagram, SiTwitter } from 'react-icons/si'
import { FaFacebookF } from 'react-icons/fa'
import { useAppDispatch, useAppSelector } from '../../store'
import { TInputEvent } from '../../global-type'
import { loginAPI } from '../../redux/actions/userActions'

function Login() {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.user)
  const [ login, setLogin ] = useState({
    email: '',
    password: '',
  })

  const { email, password } = login
  const handleLogin = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    if (!email || !password) {
      toast.error('Please checkout your information!!!')
      return false
    } else if (password.length < 8) {
      toast.error('At least 8 characters for password!!!')
      return false
    }
    if (user.err !== null) {
      toast.error(user.err?.message)
      return false
    }
    dispatch(loginAPI(login))
  }
  const handleChangeInput = (e: TInputEvent) => {
    setLogin({ ...login, [ e.target.name ]: e.target.value })
  }
  return (
    <form className="l-l" onSubmit={handleLogin}>
      <h1>B-shop</h1>
      <p>Popular Animes Art Banners</p>
      <div className="icons">
        <Link to="/" className="icon">
          <SiGoogle />
        </Link>
        <Link to="/" className="icon">
          <FaFacebookF />
        </Link>
        <Link to="/" className="icon">
          <SiTwitter />
        </Link>
        <Link to="/" className="icon">
          <SiInstagram />
        </Link>
      </div>
      <p>Login</p>

      <input
        type="email"
        name='email'
        value={email}
        placeholder="Your Email"
        onChange={handleChangeInput}
      />

      <input
        type="password"
        name="password"
        value={password}
        placeholder="Password"
        onChange={handleChangeInput}
      />

      <div className="btn-action">
        <button type="submit" name="login">
          Sign In
        </button>
      </div>
      <p className="sl-auth">
        Create an account? <Link to="/register">Register</Link>
      </p>
    </form>
  )
}

export default Login
